<span
        class="badge rounded-pill"
        [ngClass]="{
        'badge-secondary': role == RoleEnum.ADMIN,
        'badge-success': role == RoleEnum.PM,
        }">{{text}}</span>
